import { ColumnState } from 'ag-grid-community';
import { getCommonCodeList, getMinorCodeList } from 'src/apis/commonCodeApi';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { create } from 'zustand';
import { getSYS1010_R01List } from './Api_SYS1010_R01';
import { defaultSYS1010_R01Dto, SYS1010_R01Dto } from './Dto_SYS1010_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { max } from 'lodash';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface SYS1010_R01Filter {
	codeInput: string;
}

export interface Store_SYS1010_R01 {
	SYS1010_R01Filter: SYS1010_R01Filter;
	SYS1010_R01PastFilter: SYS1010_R01Filter;
	setSYS1010_R01Filter: (filter: Partial<SYS1010_R01Filter>) => void;
	setSYS1010_R01PastFilter: (filter: Partial<SYS1010_R01Filter>) => void;

	// 공통코드 관련
	majorSYS1010_R01List: SYS1010_R01Dto[];
	setMajorSYS1010_R01List: (list: SYS1010_R01Dto[], withFilteredList?: boolean) => void;
	updateMajorSYS1010_R01: (data: SYS1010_R01Dto) => void;

	// 검색된 공통코드 리스트 (실제로 보이는 리스트)
	// filteredMajorSYS1010_R01List: SYS1010_R01Dto[];
	// setFilteredMajorSYS1010_R01List: (data: SYS1010_R01Dto[]) => void;
	refreshMajorSYS1010_R01List: (selected?: SYS1010_R01Dto) => void;
	searchMajorSYS1010_R01List: (codeInput: string, selected?: SYS1010_R01Dto) => Promise<SYS1010_R01Dto[]>;

	addCodeList: (code: SYS1010_R01Dto) => void;
	
	selectedMajorSYS1010_R01: SYS1010_R01Dto | undefined;
	setSelectedMajorSYS1010_R01: (code: SYS1010_R01Dto | undefined) => void;
	initSelectedMajorSYS1010_R01: () => void;	

	codeInput: string;
	setCodeInput: (codeInput: string) => void;

	// 상세코드 관련
	minorSYS1010_R01List: SYS1010_R01Dto[];
	setMinorSYS1010_R01List: (data: SYS1010_R01Dto[]) => void;
	insertMinorSYS1010_R01List: (data: SYS1010_R01Dto[], index?: number) => void;
	removeMinorSYS1010_R01List: (index?: number) => void;
	updateMinorSYS1010_R01List: (valueIndex: number, data: SYS1010_R01Dto) => void;

	selectedMinorSYS1010_R01List: string[];
	setSelectedMinorSYS1010_R01List: (codeList: string[]) => void;
	addSelectedMinorSYS1010_R01List: (codeList: string[]) => void;
	removeSelectedMinorSYS1010_R01List: (codeList?: string[]) => void;
	initSelectedMinorSYS1010_R01List: () => void;
	allSelectedMinorSYS1010_R01List: () => void;
	

	deletedMinorSYS1010_R01List: string[];
	addDeletedMinorSYS1010_R01List: (codeList: string[]) => void;
	removeDeletedMinorSYS1010_R01List: (codeList?: string[]) => void;
	isDeleted: boolean;
	setIsDeleted: (isDeleted: boolean) => void;

	columnState: ColumnState[] | null;			setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;	setDetailColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;							setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;				setDetailFetchTrigger: (trigger: boolean) => void;

	// 초기화
	initData: () => void;
  
	// 원본 데이터 관리 추가
	originalMinorSYS1010_R01List: SYS1010_R01Dto[];	setOriginalMinorSYS1010_R01List: (list: SYS1010_R01Dto[]) => void;

	fetchSYS1010_R01: () => Promise<void>;

}

export const defaultSYS1010_R01DtoFilter : SYS1010_R01Filter = {
	codeInput: ''
};

export const useSYS1010_R01Store = create<Store_SYS1010_R01>((set, get) => ({
	SYS1010_R01Filter: defaultSYS1010_R01DtoFilter,
	SYS1010_R01PastFilter: defaultSYS1010_R01DtoFilter,
	setSYS1010_R01Filter: (filter: Partial<SYS1010_R01Filter>) => set((state) => {
		return {
			SYS1010_R01Filter: {
				...state.SYS1010_R01Filter,
				...filter
			}
		}
	}),
	setSYS1010_R01PastFilter: (filter: Partial<SYS1010_R01Filter>) => set((state) => {
		return {
			SYS1010_R01PastFilter: {
				...state.SYS1010_R01PastFilter,
				...filter
			}
		}
	}),

	majorSYS1010_R01List: [],
	setMajorSYS1010_R01List: (list: SYS1010_R01Dto[], withFilteredList?: boolean) => set((state) => ({
		...state,
		majorSYS1010_R01List: list,

	})),
	updateMajorSYS1010_R01: (data: SYS1010_R01Dto) => set((state) => {
		return {
			...state,
			majorSYS1010_R01List: state.majorSYS1010_R01List.map((item) =>
				item.majorCd === data.majorCd ? data : item
			)
		}
	}),


	refreshMajorSYS1010_R01List: async (selected?: SYS1010_R01Dto) => {
			
		//1. 전체 목록 조회 - api 호출
		const response = await getCommonCodeList(); // 전체 목록 조회

		let fetchedData: SYS1010_R01Dto[] = [];
		if (response && response.data && Array.isArray(response.data.data)) {
			fetchedData = response.data.data.map(item => {
				const { originalData, ...fetchedItem } = item;
				return {
					...defaultSYS1010_R01Dto,
					...fetchedItem,
				};
			});

		} else {
			console.warn("getCommonCodeList API 응답이 예상한 형식이 아니거나 비어있습니다.", response);
		}

		// console.log("refreshMajorCodeList response : ", fetchedData);
		
		set((state) => {
			// 현재 state.codeInput을 사용하여 가져온 fetchedData를 필터링합니다.
			const initialFilteredList = fetchedData.filter(value => {
				// value.id 와 value.majorCd, value.codeNm 의 존재 여부 및 타입 확인
				const majorCd = value.majorCd;
				const codeNm = value.codeNm;

				const majorCdMatch = typeof majorCd === 'string' && majorCd.includes(state.SYS1010_R01Filter.codeInput);
				const codeNmMatch = typeof codeNm === 'string' && codeNm.includes(state.SYS1010_R01Filter.codeInput);
				return majorCdMatch || codeNmMatch;
			});

			// 3. majorCd를 기준으로 중복 제거
			const uniqueMajorCodeMap = new Map<string, SYS1010_R01Dto>();
			for (const item of initialFilteredList) {
				if (item.majorCd && typeof item.majorCd === 'string' && !uniqueMajorCodeMap.has(item.majorCd)) {
					uniqueMajorCodeMap.set(item.majorCd, item);
				}
			}
			const deduplicatedFetchedList = Array.from(uniqueMajorCodeMap.values());

			return {
				...state,
				majorSYS1010_R01List: fetchedData,
				filteredMajorSYS1010_R01List: deduplicatedFetchedList,
				selectedMajorSYS1010_R01: selected ?? (deduplicatedFetchedList[0] ?? undefined)
			};
		});
	},

	searchMajorSYS1010_R01List: async (
		codeInput: string,
		selected?: SYS1010_R01Dto
	) => {

		// console.log("searchMajorSYS1010_R01List codeInput : ", codeInput);

		const { SYS1010_R01Filter, SYS1010_R01PastFilter, majorSYS1010_R01List, setMajorSYS1010_R01List } = get();
			

		//1. 전체 목록 조회 - api 호출
		const response = await getSYS1010_R01List(
			'search',
			{ codeInput: codeInput },
			majorSYS1010_R01List.length ?? 0
		);

		let newList = [...response.data.data ] as SYS1010_R01Dto[];

		// 2. Zustand의 set 함수를 사용하여 스토어 상태를 업데이트합니다.
		set((state) => {
			// 현재 state.codeInput을 사용하여 가져온 fetchedData를 필터링합니다.
			const initialFilteredList = newList.filter(value => {
				// value.id 와 value.majorCd, value.codeNm 의 존재 여부 및 타입 확인
				const majorCd = value.majorCd;
				const codeNm = value.codeNm;

				// console.log("state : ", JSON.stringify(state));
				// console.log("codeInput : ", codeInput);

				const majorCdMatch = typeof majorCd === 'string' && majorCd.includes(codeInput);
				const codeNmMatch = typeof codeNm === 'string' && codeNm.includes(codeInput);
				return majorCdMatch || codeNmMatch;
			});

			// 3. majorCd를 기준으로 중복 제거
			const uniqueMajorCodeMap = new Map<string, SYS1010_R01Dto>();
			for (const item of initialFilteredList) {
				if (item.majorCd && typeof item.majorCd === 'string' && !uniqueMajorCodeMap.has(item.majorCd)) {
					uniqueMajorCodeMap.set(item.majorCd, item);
				}
			}
			const deduplicatedFetchedList = Array.from(uniqueMajorCodeMap.values());

			// console.log("selected?: ", selected);
			// console.log("deduplicatedFetchedList[0]?: ", deduplicatedFetchedList[0]);
			// console.log("deduplicatedFetchedList length?: ", deduplicatedFetchedList.length);
			// console.log("uniqueMajorCodeMap.values(): ", uniqueMajorCodeMap.values());
			// console.log("nonSelectedFetchedList?: ", nonSelectedFetchedList);

			// 검색시 이미 선택한 major코드 row가 있으면 검색결과 row list에 이미 선택한 row가 있는지 확인하기
			// 검색시 이미 선택한 major코드 row가 없으면 맨 첫번째 row를 선택하기
			// 저장하고 난다음에는 선택한 row가 있는지 확인하고 있으면 선택한 row를 선택하고 없으면 그 위의 row를 선택하기

			return {
				...state,
				majorSYS1010_R01List: newList,
				filteredMajorSYS1010_R01List: deduplicatedFetchedList,
				SYS1010_R01PastFilter: SYS1010_R01Filter
			};

			
		});

		return newList;
	},

	
	addCodeList: (code: SYS1010_R01Dto) => set((state) => {

		const _codeList = [...state.majorSYS1010_R01List];
		_codeList.push(code);

		return {
			...state,
			majorSYS1010_R01List: _codeList
		}
	}),

	selectedMajorSYS1010_R01: undefined,
	setSelectedMajorSYS1010_R01: (code: SYS1010_R01Dto | undefined) => set((state) => ({
		...state,
		selectedMajorSYS1010_R01: code,
		detailFetchTrigger: true,
	})),
	initSelectedMajorSYS1010_R01: () => set((state) => ({
		...state,
		selectedMajorSYS1010_R01: undefined,
		detailFetchTrigger: false,
	})),

	
	codeInput: "",
	setCodeInput: (codeInput) => set((state) => ({
		...state,
		codeInput
	})),


	minorSYS1010_R01List: [],
	setMinorSYS1010_R01List: (data: SYS1010_R01Dto[]) => set((state) => {
		let newList: SYS1010_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultSYS1010_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			minorSYS1010_R01List: newList
		}
	}),
	insertMinorSYS1010_R01List: (data: SYS1010_R01Dto[], index?: number) => set((state) => {
		let newMinorSYS1010_R01List = [...state.minorSYS1010_R01List];

		let targetRowData = newMinorSYS1010_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newMinorSYS1010_R01List.map(item => item.valueIndex || 0)) + 1;

		// newMinorSYS1010_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newMinorSYS1010_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newMinorSYS1010_R01List에 대체
		newMinorSYS1010_R01List = newMinorSYS1010_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newMinorSYS1010_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSYS1010_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newMinorSYS1010_R01List.splice(index, 0, ...newData);
		} else {
			newMinorSYS1010_R01List.push(...newData);
		}
		
		return {
			...state,
			minorSYS1010_R01List: newMinorSYS1010_R01List
		}
	}),
	removeMinorSYS1010_R01List: (index?: number) => set((state) => {
		const newMinorSYS1010_R01List = [...state.minorSYS1010_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			minorSYS1010_R01List: newMinorSYS1010_R01List
		}
	}),
	updateMinorSYS1010_R01List: (valueIndex: number, data: SYS1010_R01Dto) => set((state) => {
		const _minorSYS1010_R01List = state.minorSYS1010_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.dispSeq && data.dispSeq < 1) {
			showWarning('순서는 1보다 작을 수 없습니다.');
			data.dispSeq = 1;
		}
		return {
			...state,
			minorSYS1010_R01List: _minorSYS1010_R01List
		}
	}),

	selectedMinorSYS1010_R01List: [],
	setSelectedMinorSYS1010_R01List: (codeList: string[]) => set((state) => ({
		...state,
		selectedMinorSYS1010_R01List: codeList
	})),
	addSelectedMinorSYS1010_R01List: (codeList: string[]) => set((state) => {
		const _selectedMinorSYS1010_R01List = [...state.selectedMinorSYS1010_R01List];
		if(codeList.length > 0) {
			_selectedMinorSYS1010_R01List.push(...codeList);
		}
		return {
			...state,
			selectedMinorSYS1010_R01List: _selectedMinorSYS1010_R01List
		}
	}),
	removeSelectedMinorSYS1010_R01List: (codeList?: string[]) => set((state) => ({
		...state,
		selectedMinorSYS1010_R01List: [...state.selectedMinorSYS1010_R01List].filter(value => codeList ? !codeList.includes(value) : false)
	})),
	initSelectedMinorSYS1010_R01List: () => set((state) => ({ ...state, selectedMinorSYS1010_R01List: [] })),
	allSelectedMinorSYS1010_R01List: () => set((state) => {
		const _selectedMinorSYS1010_R01List = [...state.minorSYS1010_R01List.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedMinorSYS1010_R01List: _selectedMinorSYS1010_R01List
		}
	}),

	deletedMinorSYS1010_R01List: [],
	addDeletedMinorSYS1010_R01List: (codeList: string[]) => set((state) => {
		const _deletedMinorSYS1010_R01List = [...state.deletedMinorSYS1010_R01List];


		for(const valueIndex of codeList) {

			const isInserted = state.minorSYS1010_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.minorSYS1010_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedMinorSYS1010_R01List.push(valueIndex);
			}
		}
		return {
			...state,
			deletedMinorSYS1010_R01List: _deletedMinorSYS1010_R01List
		}
	}),
	removeDeletedMinorSYS1010_R01List: (codeList?: string[]) => set((state) => ({
		...state,
		deletedMinorSYS1010_R01List: [...state.deletedMinorSYS1010_R01List].filter(value => codeList ? !codeList.includes(value) : false),
		isDeleted: false
	})),
	isDeleted: false,
	setIsDeleted: (isDeleted: boolean) => set((state) => ({
		...state,
		isDeleted
	})),
	
	columnState: null,			setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	
	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	initData: () => set((state) => ({
		...state,
		SYS1010_R01Filter: defaultSYS1010_R01DtoFilter,
		SYS1010_R01PastFilter: defaultSYS1010_R01DtoFilter,
		columnState: null,
		detailColumnState: null,
		majorSYS1010_R01List: [],
		minorSYS1010_R01List: [],
		selectedMinorSYS1010_R01List: [],
		deletedMinorSYS1010_R01List: [],
		filteredMajorSYS1010_R01List: [],
		selectedMajorSYS1010_R01: undefined,
		allCount: 0,
		scrollTop: null,
		detailScrollTop: null,
		detailFetchTrigger: false,
	})),
  
	originalMinorSYS1010_R01List: [],
	setOriginalMinorSYS1010_R01List: (list) => set((state) => {
		let newList: SYS1010_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			newList.push({ 
				...defaultSYS1010_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMinorSYS1010_R01List: newList
		}
	}),

	
	fetchSYS1010_R01: async () => {
		// 1. 대분류(타이틀/그룹명)만 저장
		const response = await getCommonCodeList();
		const codeList = response.data.data;
		set({ majorSYS1010_R01List: codeList.map(item => {
			const { originalData, ...fetchedItem } = item;
			return {
				...defaultSYS1010_R01Dto,
				...fetchedItem,
			};
		})});

		// 2. 상세코드(드롭다운용)는 getMinorCodeList로 병렬 fetch
		const [brandRes, itemGroupRes, itemAccountRes, unitRes] = await Promise.all([
			getMinorCodeList("BRANDCD"),
			getMinorCodeList("ITEMGROUP"),
			getMinorCodeList("ITEMACCOUNT"),
			getMinorCodeList("UNIT"),
		]);

		const { setBrandCdList, setItemGroupList, setItemAccountList, setUnitList } = useCommonCodeStore.getState();

		setBrandCdList(brandRes.data.data);
		setItemGroupList(itemGroupRes.data.data);
		setItemAccountList(itemAccountRes.data.data);
		setUnitList(unitRes.data.data);


	},

}));
